import { Box } from '@quintoandar-tokko/jopijs';
import ItemCount from '../components/ItemCount';
import LeadStatusBadge from '../components/LeadStatusBadge';
import styles from './overviewLeads.module.scss';

export default function OverviewLeadRow({
  stats = {
    text: '',
    contacts: '',
    backgroundColor: '',
  },
  className = '',
  ...rest
}) {
  const classNames = `${styles.rowWrapper} ${className}`;

  return (
    <Box className={classNames} {...rest}>
      <Box className={styles.overviewLeadsRow}>
        <LeadStatusBadge
          backgroundColor={stats.backgroundColor}
          text={stats.text}
        />
        <ItemCount icon="icon-contactos" value={stats.contacts} />
      </Box>
    </Box>
  );
}
